

































import ModalBox from "@/components/Common/Modals/ModalBox.vue";
import { computed, onUnmounted, ref } from "@vue/composition-api";
import { storeToRefs } from "pinia";
import { useFinancePaymentModal } from "@/stores/webmaster/finance/modal/financePaymentModal";
import LTaglist from "@/components/Common/LTaglist.vue";
import PaymentTemplate from "@/components/Webmaster/Finance/modal/FinancePaymentModal/PaymentTemplate.vue";
import RequisiteTemplate from "@/components/Webmaster/Finance/modal/FinancePaymentModal/RequisiteTemplate.vue";
import AutoPaymentTemplate from "@/components/Webmaster/Finance/modal/FinancePaymentModal/AutoPaymentTemplate.vue";
import { useRequisiteStore } from "@/stores/webmaster/finance/modal/requisiteStore";
import { usePayoutStore } from "@/stores/webmaster/finance/modal/payoutStore";
import { useAutoPayments } from "@/stores/webmaster/finance/modal/autoPaymentsStore";
import storeInstance from "@/store";
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const payoutStore = usePayoutStore();
  const requisiteStore = useRequisiteStore();
  const autoPaymentsStore = useAutoPayments();
  const financePaymentModalStore = useFinancePaymentModal();
  const {
    isActive,
    currentTab
  } = storeToRefs(financePaymentModalStore);
  const tabs = computed(() => {
    const tabs = ["payout", "addRequisite"];
    if (!isDomestic.value) {
      tabs.push("autoPayout");
    }
    return tabs.map(item => {
      return {
        name: item,
        id: item
      };
    });
  });
  const payoutRef = ref();
  const addRequisiteRef = ref();
  const autoPayoutRef = ref();
  const isDomestic = computed(() => {
    return storeInstance.state.webmaster.profile.user.detail.isDomestic;
  });
  async function submit() {
    switch (currentTab.value) {
      case "payout":
        await payoutRef.value?.submit();
        close();
        break;
      case "addRequisite":
        await addRequisiteRef.value?.submit();
        break;
      case "autoPayout":
        autoPayoutRef.value?.submit();
        break;
    }
  }
  function close() {
    financePaymentModalStore.$reset();
    requisiteStore.$reset();
    payoutStore.$reset();
    autoPaymentsStore.$reset();
  }
  onUnmounted(() => {});
  return {
    isActive,
    currentTab,
    tabs,
    payoutRef,
    addRequisiteRef,
    autoPayoutRef,
    submit,
    close
  };
};
__sfc_main.components = Object.assign({
  ModalBox,
  LTaglist,
  PaymentTemplate,
  RequisiteTemplate,
  AutoPaymentTemplate
}, __sfc_main.components);
export default __sfc_main;
